<template>
  <section style="position: relative;">
    <section class="grid-flex column">
      <!-- filters -->
      <div class="flex-1 w100">
        <div class="flex row w100 middle">
          <div class="flex-1 flex">
            <tabs :data="reportTabs" v-model="currentTab" :disable="checkHaveCampaign" :disableMsg="disableMsg" :key="currentTab" ></tabs>
          </div>
          <div class="flex-1 flex row end w100">
            <div style="margin-right: 8px;" class="flex column no-mobile">
              <label>Editar</label>
              <div class="flex end w100" style="margin-top:12px">
                <div class="button secondary" @click="showModalEdit = true">
                  <i class="fas fa-edit"></i>
                </div>
              </div>
            </div>
            <div class="flex column no-mobile" style="margin-right: 14px;">
              <label>Atualizar</label>
              <div class="flex end w100" style="margin-top:14px">
                <div @click="forceRefreshData()" class="button secondary">
                  <i class="fas fa-sync-alt"></i>
                </div>
              </div>
            </div>
            <div class="flex-1 w100 filter-item">
              <label>Tracking: </label>
              <select class="input" v-model="filters.data.tracking">
                <option v-for="(c, index) in filters.list.listTrack" :key="index" :value="c.value" :selected="c.value === filters.data.tracking">
                  {{ c.label }}
                </option>
              </select>
            </div>
            <div v-if="currentTab!='account'" class="flex-1 w100 filter-item">
              <label>Ordenar por: </label>
              <select class="input" v-model="filters.data.order_by">
                <option v-for="(c, index) in filters.list.listOrderBy" :key="index" :value="c.value" :selected="c.value === filters.data.order_by">
                  {{ c.label }}
                </option>
              </select>
            </div>
            <div v-if="currentTab!='account'" class="flex-1 w100 filter-item">
              <label>Ordenação: </label>
              <select class="input" v-model="filters.data.order">
                <option v-for="(c, index) in filters.list.listOrder" :key="index" :value="c.value" :selected="c.value === filters.data.order">
                  {{ c.label }}
                </option>
              </select>
            </div>
            <ltk-date-picker
              label="Filtro de data"
              v-model="filters.data.date"
              :loading="loading"
            ></ltk-date-picker>
          </div>
        </div>
      </div>
    </section>

    <modal
      title="Editar Colunas"
      :show="showModalEdit"
      @close="showModalEdit = false"
    >
      <div class="content flex column" slot="content">
        <div class="flex column w100">
            <div class="flex-1 w100 litem ">
                <b>Nome da Campanha</b>
              </div>
              <div class="flex-1 w100 litem">
                  <b>Orçamento</b>
              </div>
              <div class="flex-1 litem flex middle between w100">
                  <b>Valor Gasto</b>
                  <m-switch
                    v-model="stats.spend"
                  ></m-switch>
              </div>
              <div class="flex-1 litem flex middle between w100">
                  <b>Vendas (CPA)</b>
                  <m-switch
                    v-model="stats.sales"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                <b>
                  Vendas LH
                  <span class="info tooltip">
                    <span class="tooltiptext">Total e CPA das vendas TRACKEADS. Contando CANCELADAS</span>
                  </span>
                </b>
                <m-switch
                    v-model="stats.sales_lh"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                <b>
                  Valor LH
                  <span class="info tooltip">
                    <span class="tooltiptext">Valor total das vendas TRACKEADAS. Contando CANCELADAS</span>
                  </span>
                </b>
                <m-switch
                    v-model="stats.value_lh"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                <b>
                  Vendas A. LH
                  <span class="info tooltip">
                    <span class="tooltiptext">Total e CPA das vendas APROVADAS. </span>
                  </span>
                </b>
                <m-switch
                    v-model="stats.sales_p_lh"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                <b>
                  Valor A. LH
                  <span class="info tooltip">
                    <span class="tooltiptext">Valor total das vendas APROVADAS. </span>
                  </span>
                </b>
                <m-switch
                    v-model="stats.value_p_lh"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                <b>
                  Leads LH
                  <span class="info tooltip">
                    <span class="tooltiptext">Leads capturados pela Único.</span>
                  </span>
                </b>
                <m-switch
                    v-model="stats.lead_lh"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                <b>
                  Conversas LH
                  <span class="info tooltip">
                    <span class="tooltiptext">Conversas capturadas pela Único.</span>
                  </span>
                </b>
                <m-switch
                    v-model="stats.message_lh"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                <b>
                  Roas LH
                  <span class="info tooltip">
                    <span class="tooltiptext">Roas feito a partir das VENDAS APROVADAS.</span>
                  </span>
                </b>
                <m-switch
                    v-model="stats.roas_p_lh"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                <b>
                  Tax.Conv
                  <span class="info tooltip">
                    <span class="tooltiptext">Taxa de conversão sobre as VENDAS APROVADAS.</span>
                  </span>
                </b>
                <m-switch
                    v-model="stats.conversion_p_lh"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>Leads</b>
                  <m-switch
                    v-model="stats.lead"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>Conversas Iniciadas</b>
                  <m-switch
                    v-model="stats.messages"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>Impressoes</b>
                  <m-switch
                    v-model="stats.impression"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>CPM</b>
                  <m-switch
                    v-model="stats.cpm"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>Cliques</b>
                  <m-switch
                    v-model="stats.clicks"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>CTR</b>
                  <m-switch
                    v-model="stats.ctr"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>Tax. Conversão</b>
                  <m-switch
                    v-model="stats.conversion"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>Connect Rate</b>
                  <m-switch
                    v-model="stats.connect_rate"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>Visualizações de Página</b>
                  <m-switch
                    v-model="stats.pageview"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>Visualizações de Conteúdo</b>
                  <m-switch
                    v-model="stats.view_content"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>Adições ao Carrinho</b>
                  <m-switch
                    v-model="stats.add_to_cart"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>Iniciação de Checkout</b>
                  <m-switch
                    v-model="stats.initate_checkout"
                  ></m-switch>
              </div>
              <div class="litem flex-1 txt-center flex middle between w100">
                  <b>Add Info Pagamento</b>
                  <m-switch
                    v-model="stats.add_payment_info"
                  ></m-switch>
              </div>
        </div>
        <div class="flex column w100">
          <div class="flex w100 center margin-top-l">
            <div class="button secondary" style="margin-right: 8px;" @click="showModalEdit = false">FECHAR</div>

            <div class="button primary" @click="updateDashCampaign()">SALVAR</div>
          </div>
        </div>
      </div>
    </modal>

    <!-- account -->
    <account 
      v-if="currentTab === 'account'" 
      :filters="filters"
      :columns="stats"
      :accountsFilter="accountSelecteds"
      @accountSelected="addAccount($event)"
      @accountRemoved="removeAccount($event)"
      @cleanAccountSelect="cleanAccount($event)"
    ></account>
    <!-- campaign -->
    <campaign 
      v-if="currentTab === 'campaign'" 
      :filters="filters"
      :columns="stats"
      :accountsFilter="accountSelecteds"
      :campaignsFilter="campaignsSelecteds"
      @campaignSelected="addCampaign($event)"
      @campaignRemoved="removeCampaign($event)"
      @cleanCampaignSelect="cleanCampaign($event)"
    ></campaign>
    <!-- adgroup -->
    <ad-group 
      v-if="currentTab === 'adgroup'" 
      :filters="filters"
      :columns="stats"
      :accountsFilter="accountSelecteds"
      :campaignsFilter="campaignsSelecteds"
      :adGroupFilter="adGroupSelecteds"
      @adgSelected="addAdg($event)"
      @adgRemoved="removeAdg($event)"
      @cleanAdgSelect="cleanAdg($event)"
    >
    </ad-group>
    <!-- ad -->
    <ad 
      v-if="currentTab === 'ad'"
      :filters="filters"
      :columns="stats"
      :accountsFilter="accountSelecteds"
      :campaignsFilter="campaignsSelecteds"
      :adGroupFilter="adGroupSelecteds"
    ></ad>
  </section>
</template>

<script>
import Tabs from "@/components/tabs/Tabs";
import ltkDatePicker from "@/components/datepicker/LtkDatePicker";

import Account from "./Account";
import Campaign from "./Campaign";
import AdGroup from "./AdGroup";
import Ad from "./Ad";
import Modal from "@/components/modal/Modal";
import MSwitch from "@/components/MSwitch.vue";

import {
  getDashCampaign,
  updateDashCampaign,
} from "@/services/dashCampaign";

import moment from "moment";
moment.locale("pt-br");

const EMPTYSTATE = {
    spend: true,
    sales: true,
    sales_lh: true,
    value_lh: true,
    sales_p_lh: true,
    value_p_lh: true,
    lead_lh: true,
    message_lh: true,
    roas_p_lh: true,
    conversion_p_lh: true,
    lead: true,
    messages: true,
    impression: true,
    cpm: true,
    clicks: true,
    ctr: true,
    conversion: true,
    connect_rate: true,
    pageview: true,
    view_content: true,
    add_to_cart: true,
    initate_checkout: true,
    add_payment_info: true,
  }

export default {
  name: "campaign-dash",
  components: {
    Tabs,
    Account,
    Campaign,
    AdGroup,
    Ad,
    ltkDatePicker,
    Modal,
    MSwitch
  },
  props: ['slug'],
  data() {
    return {
      loading: false,
      accountSelecteds: [],
      campaignsSelecteds: [],
      adGroupSelecteds: [],
      disableMsg: "Você precisa selecionar pelo menos uma campanha!",
      showModalEdit: false,
      filters: {
        data: {
          refresh: false,
          date: [
            moment()
              .add(-0, "d")
              .startOf("day")
              .toDate(),
            moment()
              .startOf("day")
              .toDate(),
          ],
          order: 'desc',
          order_by: 'status',
          tracking: ''
        },
        list: {
          listOrderBy: [
            {
              value: 'status',
              label: 'Ativas'
            },
            {
              value: 'id',
              label: 'Data de Criação'
            },
            {
              value: 'spend',
              label: 'Valor Gasto'
            },
            {
              value: 'sales',
              label: 'Vendas (FBADS / GADS)'
            },
            {
              value: 'sales_lh',
              label: 'Vendas LH'
            },
            {
              value: 'sales_cost',
              label: 'CPA (FBADS / GADS)'
            },
            {
              value: 'sales_lh_cost',
              label: 'CPA LH'
            },
            {
              value: 'roas_lh',
              label: 'ROAS LH'
            },
            {
              value: 'conversion',
              label: 'Conversão (FBADS / GADS)'
            },
            {
              value: 'conversion_lh',
              label: 'Conversão LH'
            }
          ],
          listTrack: [
            {
              value: '',
              label: 'Jornada da Compra'
            },
            {
              value: 'FIRST_PV',
              label: 'Primeiro Clique'
            },
            {
              value: 'LAST_PV',
              label: 'Último Clique'
            },
          ],
          listOrder: [
            {
              value: 'desc',
              label: 'Do Maior para o Menor'
            },
            {
              value: 'asc',
              label: 'Do Menor para o Maior'
            },
          ]
        },
      },
      currentTab: "campaign",
      stats: Object.assign({}, EMPTYSTATE)
    };
  },
  mounted() {
    if (this.slug) {
      this.currentTab = this.slug
    }

    this.getDashCampaign()
  },
  computed: {
    // FIXME: AJUSTAR ISSO PARA SELECIONAR ACCOUNT
    checkHaveCampaign() {
      return false

      // if (this.campaignsSelecteds.length > 0) { 
      //   return false
      // }

      // if (this.currentTab == 'campaign') {
      //   return false
      // }

      // return true
    },
    reportTabs() {
      let account = 'Conta de Anúncio'
      if (this.accountSelecteds.length > 0) {
        account = `${account} (${this.accountSelecteds.length})`
      }

      let campaigns = 'Campanhas'
      if (this.campaignsSelecteds.length > 0) {
        campaigns = `${campaigns} (${this.campaignsSelecteds.length})`
      }

      let adgroup = 'Conjuntos de Anúncios'
      if (this.adGroupSelecteds.length > 0) {
        adgroup = `${adgroup} (${this.adGroupSelecteds.length})`
      }

      return [
          {
            name: "account",
            title: account,
          },
          {
            name: "campaign",
            title: campaigns,
          },
          {
            name: "adgroup",
            title: adgroup,
          },
          {
            name: "ad",
            title: "Anúncios",
          },
        ]
      },
  },
  watch: {
    slug() {
      if (this.slug) {
        this.currentTab = this.slug
      } 
    },
    currentTab(value) {
      if (this.slug === value) {
        return
      }

      this.$router.push({ name: "CampaignDash", params: { slug: this.currentTab } });
    }
  },
  methods: {
    getDashCampaign() {
      this.loading = true
      getDashCampaign()
        .then((result) => {
          if (result.custom_fields && result.custom_fields.showColumns) {
            this.stats = result.custom_fields.showColumns 
          } else {
              this.stats = Object.assign({}, EMPTYSTATE)
          }
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateDashCampaign() {
      let params = {
        custom_fields: {
          showColumns: this.stats,
          orderColumns: []
        }
      } 
      updateDashCampaign(params)
        .then(() => {
          this.$toast.success({
            title:'Sucesso',
            message:'Editado com sucesso'
          })

          this.showModalEdit = false
        })
        .catch(() => {
          this.$toast.error({
            title:'Erro',
            message:'Ocorreu algum problema'
          })
        })
    },
    forceRefreshData() {
      this.filters.data.refresh = !this.filters.data.refresh 
    },
    addAccount(accountId) {
      this.accountSelecteds.push(accountId)
      // reset campaigns
      this.campaignsSelecteds = []
      // reset adgroup
      this.adGroupSelecteds = []
    },
    removeAccount(accountId) {
      this.accountSelecteds = this.accountSelecteds.filter( e => e !== accountId)
      // reset campaigns
      this.campaignsSelecteds = []
      // reset adgroup
      this.adGroupSelecteds = []
    },
    cleanAccount() {
      this.accountSelecteds = []
      this.campaignsSelecteds = []
      this.adGroupSelecteds = []
    },
    addCampaign(campId) {
      this.campaignsSelecteds.push(campId)
      // reset adgroup
      this.adGroupSelecteds = []
    },
    removeCampaign(campId) {
      this.campaignsSelecteds = this.campaignsSelecteds.filter( e => e !== campId)
      // reset adgroup
      this.adGroupSelecteds = []
    },
    cleanCampaign() {
      this.campaignsSelecteds = []
      this.adGroupSelecteds = []
    },
    cleanAdg() {
      this.adGroupSelecteds = []
    },
    addAdg(adgId) {
      this.adGroupSelecteds.push(adgId)
    },
    removeAdg(adgId) {
      this.adGroupSelecteds = this.adGroupSelecteds.filter( e => e !== adgId)
    },
  },

};
</script>

<style lang="scss" scoped>

.filter-item {
  max-width: 200px;
  .input {
    min-width: 100px;
  }
}

.litem {
  padding: 4px 4px;
  border-bottom: 1px solid #c2c2c2;
}

@media screen and (max-width: 1024px) {
  .filter-item {
    max-width: 100% !important;
  }
}
</style>
